// extracted by mini-css-extract-plugin
export default {"container":"ExternalLink_container__fRYPo","link":"ExternalLink_link__6WerA"};